import React from "react";
import librarylogo from "../images/librarylogo-white.png";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-logo">
        <img
          src={librarylogo}
          alt="Literature & Arts Corner Library logo"
          className="img-fluid"
          width="350"
        />
      </div>
    </div>
  );
};
